import { ReactNode, useEffect } from "react";

import { usePostHog } from "posthog-js/react";

import { userSelector } from "../../app/main/mainSlice";
import { useAppSelector } from "../../app/store/hooks";
import { useUpAuth } from "./UpAuth";

const PostHogIdentify = ({ children }: { children: ReactNode }) => {
    const posthog = usePostHog();
    const { isAuthenticated } = useUpAuth()

    const user = useAppSelector(userSelector)
    useEffect(() => {
        if (isAuthenticated) {
            posthog.identify(user?.id);
        } else {
            posthog.reset()
        }
    }, [isAuthenticated, user?.id, posthog])

    return (
        <>
            {children}
        </>
    )
}

export default PostHogIdentify
